import { toast } from '@randstad-lean-mobile-factory/react-components-core';
import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { RoutingColumnUniqueValues, RoutingsService } from '../../Services/API';
import { QueryKeys } from '../types';

export const useFetchUniqueColumnValues = (
  extraOptions?: UseQueryOptions<RoutingColumnUniqueValues, AxiosError>
) => {
  return useQuery<RoutingColumnUniqueValues, AxiosError>(
    [QueryKeys.fetchUniqueColumnValues],
    async () => {
      return await RoutingsService.routingsControllerFetchUniqueColumnValues();
    },
    {
      onError: () => {
        toast.error('Erreur lors de la récupération des valeurs uniques des routages');
      },
      staleTime: 300000,
      cacheTime: 300000,
      refetchOnWindowFocus: false,
      ...extraOptions,
    }
  );
};
